// 试题类型
// "单选", "多选", "判断", "高阶","填空"
const questionType = {
    0: {
        text: '实操',
        icon: ''
    },
    1: {
        text: '单选',
        icon: ''
    },
    2: {
        text: '多选',
        icon: ''
    },
    3: {
        text: '判断',
        icon: ''
    },
    4: {
        text: '高阶',
        icon: ''
    },
    5: {
        text: '问答',
        icon: ''
    },
    6: {
        text: '填空',
        icon: ''
    },
    7: {
        text: '组合',
        icon: ''
    }
}
export default {
    questionType
}
